import React, { useState } from 'react';
import './LinkModal.css';

function LinkModal({ selectedText, onSubmit, onClose }) {
    const [url, setUrl] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (url.trim()) {
            onSubmit(url.trim());
        } else {
            alert('Please enter a valid URL.');
        }
    };

    const handleUrlChange = (e) => {
        setUrl(e.target.value);
    };

    return (
        <div className="link-modal-backdrop">
            <div className="link-modal-content">
                <h3>Insert Link</h3>
                {selectedText && <p>Text to link: "{selectedText}"</p>}
                <form onSubmit={handleSubmit}>
                    <label>
                        URL:
                        <input
                            type="url"
                            value={url}
                            onChange={handleUrlChange}
                            placeholder="https://duuzra.com"
                            required
                            autoFocus
                        />
                    </label>
                    <div className="link-modal-actions">
                        <button type="submit">OK</button>
                        <button type="button" onClick={onClose}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default LinkModal;
